import { createSelector, DuckSelector } from '@atc/modular-redux';
import _get from 'lodash/get';
const DEFAULT_EMPTY_SEARCHES = [];
const DEFAULT_EMPTY_CRITERIA = [];
export default () => ({
  getRecentSearches: state => _get(state, 'recentSearch.inventorySearches', DEFAULT_EMPTY_SEARCHES),
  // excludes current search
  getLatestRecentSearches: new DuckSelector(selectors => createSelector(selectors.getRecentSearches, recentSearches => recentSearches?.slice(1))),
  getLastRecentSearchCriteria: new DuckSelector(selectors => createSelector(selectors.getRecentSearches, function (searches) {
    if (searches === void 0) {
      searches = [];
    }
    if (searches.length > 0) {
      const {
        query
      } = searches[0];
      if (query) {
        const result = {};
        Object.keys(query).forEach(filter => {
          // convert values into array
          result[filter] = typeof query[filter] === 'string' ? query[filter].split(',') : query[filter];
        });
        return result;
      }
    }
    return DEFAULT_EMPTY_CRITERIA;
  }))
});